import React from "react";

import classnames from "classnames";

import styles from "./DataTable.scss";
import { Alignment, TableDataType } from "./types";

interface TableCellProps {
  renderCell: (dataItem: TableDataType) => React.ReactNode | string;
  alignment?: Alignment;
  dataItem: TableDataType;
  width?: string;
}

export function TableCell({
  alignment,
  dataItem,
  renderCell,
  width,
}: TableCellProps): React.ReactElement {
  const cellClass = classnames(styles.cell, {
    [styles[`align_${alignment}`]]: Boolean(alignment),
  });

  return (
    <td width={width} className={cellClass}>
      {renderCell(dataItem)}
    </td>
  );
}
